module.exports = __webpack_public_path__ + "static/media/FM_EU_Investor_Compensation_Fund_March_2025.f15c63a6.pdf";